import { Alert, Button, Field, Modal, TextInput, useToast } from "@nabble/ui";
import { type FormEvent, useState } from "react";
import { addEmail } from "../../../../api/accountEmails";
import { useEmailFormSubmit } from "./useEmailFormSubmit";

/** Adds a secondary email; it counts once the link sent to it is opened. */
export function AddEmailDialog({ onClose, onAdded }: { onClose: () => void; onAdded: () => void }): React.JSX.Element {
  const { show } = useToast();
  const [email, setEmail] = useState("");
  const { loading, errors, run } = useEmailFormSubmit("We couldn't add the email.");

  async function submit(e?: FormEvent): Promise<void> {
    e?.preventDefault();
    const value = email.trim();
    if (!value) return;
    await run(async () => {
      await addEmail(value);
      show({ title: `We sent a confirmation link to ${value}`, tone: "success" });
      onAdded();
    });
  }

  return (
    <Modal
      open
      icon="mail"
      title="Add email"
      description="We'll send it a link. Once you open it, the email is confirmed."
      onClose={onClose}
      actions={
        <>
          <Button label="Cancel" variant="secondary" onClick={onClose} />
          <Button label="Add email" icon="plus" loading={loading} disabled={!email.trim()} onClick={() => void submit()} />
        </>
      }
    >
      <form onSubmit={(e) => void submit(e)} className="nb-stack" noValidate>
        <Field label="Email" error={errors.email}>
          <TextInput type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </Field>
        {errors.other ? <Alert tone="danger">{errors.other}</Alert> : null}
      </form>
    </Modal>
  );
}
